<template>
	<v-dialog
		:value="value"
		persistent
		max-width="1000px">
		<v-card class="overflow-x-hidden">
			<v-card-title>
				ARG/Vendor Code of Conduct
			</v-card-title>
			<v-card-text class="mx-4">
				<ol>
					<li>
						<strong>The vendor/broker maintains responsibility for promo accuracy including but not limited to:</strong>
						<ol type="a">
							<li>Correct net unit cost</li>
							•	Vendor/broker will be responsible for covering net unit cost differences if changes are received after promotion deadlines
							<li>Correct group/store inclusion/exclusion</li>
							<li>Correct Item inclusion/exclusion</li>
							<li>Correct dates</li>
						</ol>
					</li>
					<br/>
					<li>
						<strong>Vendor/broker will enter deals prior to their submission deadline:</strong>
						<ol type="a">
							<li>
								Non-Perishables
								<ul style="list-style-type: '• ';">
									<li>Ad Deals – To be submitted at time of event window contract submission, absolutely no later than 8 weeks prior to the ad date </li>
									<li>TPR Deals – To be submitted at time of event window contract submission, absolutely no later than 4 weeks prior to the TPR date</li>
									<li>Absolutely no promo revisions will be accepted after promotion start date</li>
									<li><strong>Note: </strong>Only critical price improvement submissions will be allowed after these deadlines and 2 weeks before execution</li>
								</ul>
							</li>
							<li>
								Perishable
								<ul style="list-style-type: '• ';">
									<li>Ad Deals – Submitted at time of event window contract submission, absolutely no later than  4 weeks prior to the ad date</li>
									<li>TPR Deals – Submitted at time of event window contract submission, absolutely no later than  4 weeks prior to the TPR date</li>
								</ul>
							</li>
						</ol>
					</li>
					<br/>
					<li>
						<strong>If ARG makes requested changes for Vendor review, Vendor/broker owes response within 48 hours:</strong>
						<ol type="a">
							<li>Failure to make or discuss requested changes within 48 hours will result in automatic acceptance of change requests</li>
						</ol>
					</li>
				</ol>
			</v-card-text>
			<v-card-actions class="mt-8">
				<v-col>
					<v-row align="center" class="mx-4">
						<v-btn
							:style="styleObject"
							@click.prevent="logout">
							<v-icon color="#fff" class="mr-2">mdi-logout</v-icon>
							<span>Logout</span>
						</v-btn>
						<v-spacer></v-spacer>
						<v-checkbox v-model="isAccepted" label="Accept Code of Conduct"></v-checkbox>
						<v-btn @click.prevent="update" :disabled="!isAccepted" color="primary" class="ml-8">
							<span>Confirm</span>
						</v-btn>
					</v-row>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>

export default {
	name: 'CodeOfConductModal',
	props: ['value'],
	data() {
		return {
		isAccepted: false,
		styleObject: {
				background: '#E53935',
				color: 'white',
				fontSize: '15px'
			},
	}
	},
	methods: {
		update() {
			this.$emit('update')
		},
		logout() {
			this.$emit('logout')
		}
	}
}
</script>